module.exports = __webpack_public_path__ + "static/Statutory-Compliance-cf82933db88e222d552450a22d5720d9.png";